export const BLOOD_SCALE = 1.5;

const BLOOD_COUNT = 35;
const BLOOD_GRAVITY = 3200;
const BLOOD_AIR_DRAG = 0.94;
const BLOOD_VELOCITY = [200, 900];
const BLOOD_SPREAD = 60;
const BLOOD_FADE = 2.0;
const BLOOD_LIFESPAN = [0.4, 0.9];

function bloodColor(k) {
    return k.rgb(
        k.rand(140, 220),
        k.rand(0, 40),
        k.rand(0, 40),
    );
}

export function addBloodExplosion(k, opt = {}) {
    const sample = (s) => typeof s === "function" ? s() : s;
    const origin = sample(opt.pos ?? k.vec2(0, 0));

    for (let i = 0; i < (opt.count ?? BLOOD_COUNT); i++) {
        const isJet = k.chance(0.45);
        const size = k.rand(4, 6) * BLOOD_SCALE;

        const p = k.add([
            k.pos(origin),
            isJet
                ? k.rect(size * k.rand(1.5, 3), size)
                : k.circle(size),
            k.color(bloodColor(k)),
            k.opacity(1),
            k.lifespan(k.rand(BLOOD_LIFESPAN[0], BLOOD_LIFESPAN[1])),
            k.scale(1),
            k.anchor("center"),
            k.z(50),
            k.rotate(k.rand(0, 360)),
        ]);

        const gravity = (opt.gravity ?? BLOOD_GRAVITY) * BLOOD_SCALE;
        const airDrag = opt.airDrag ?? BLOOD_AIR_DRAG;
        const spread = opt.spread ?? BLOOD_SPREAD;
        const headingBase = sample(opt.heading ?? -90);
        const head = headingBase + k.rand(-spread / 2, spread / 2);
        const vel = sample(opt.velocity ?? k.rand(BLOOD_VELOCITY[0], BLOOD_VELOCITY[1])) * BLOOD_SCALE;

        let velX = Math.cos(k.deg2rad(head)) * vel;
        let velY = Math.sin(k.deg2rad(head)) * vel;
        const fade = opt.fade ?? BLOOD_FADE;

        p.onUpdate(() => {
            velY += gravity * k.dt();
            p.pos.x += velX * k.dt();
            p.pos.y += velY * k.dt();

            velX *= airDrag;
            velY *= airDrag;

            if (isJet) {
                const angleRad = Math.atan2(velY, velX);
                p.angle = angleRad * 180 / Math.PI;

                const speed = Math.sqrt(velX * velX + velY * velY);
                const stretch = 1 + speed / 1800;
                p.scaleTo(k.vec2(stretch, 1));
            } else {
                const s = 0.9 + k.wave(-0.1, 0.1, k.time() * k.rand(6, 12));
                p.scaleTo(k.vec2(s, s));
            }

            p.opacity -= fade * k.dt();
        });
    }

    return k.wait(BLOOD_LIFESPAN[1]);
}